import React from 'react';
import { Modal, Form, Input, Select, Row, Col } from 'antd';

const { Option } = Select;

export default function BiometricMappingModal({
  open,
  editingMap,
  form,
  onSave,
  onCancel,
  mapPersonType,
  setMapPersonType,
  isStudio,
  staffList,
  candidatesList,
  academicYears,
  ayFilter,
  standardFilter
}) {
  return (
    <Modal
      title={editingMap ? "Edit Biometric User Mapping" : "Map Biometric User ID to Individual"}
      open={open}
      onOk={onSave}
      onCancel={onCancel}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="biometric_user_id" label="Biometric Machine User ID" rules={[{ required: true, message: 'Enter device ID (e.g. 101)' }]}>
              <Input placeholder="Device ID scanned on eSSL machine (e.g. 101)" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="badge_number" label="RFID Card / Badge Number">
              <Input placeholder="Optional (e.g. 0009876543)" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="device_role" label="Machine Privilege / Role" rules={[{ required: true }]}>
              <Select>
                <Option value="USER">Normal User (Pri 0)</Option>
                <Option value="ADMIN">Device Administrator (Pri 14)</Option>
                <Option value="MANAGER">Device Manager (Pri 2)</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="person_type" label="Map To (Individual Type)" rules={[{ required: true }]}>
              <Select onChange={(val) => setMapPersonType(val)} disabled={isStudio}>
                {!isStudio && <Option value="STAFF">Staff Member</Option>}
                <Option value="CANDIDATE">Candidate</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {mapPersonType === 'STAFF' ? (
          <Form.Item name="staff_id" label="Select Staff Member" rules={[{ required: true }]}>
            <Select placeholder="Choose staff member..." showSearch optionFilterProp="children">
              {staffList.map(s => (
                <Option key={s.staff_id} value={s.staff_id}>
                  {s.staff_name} ({s.staff_code || `ID: ${s.staff_id}`})
                </Option>
              ))}
            </Select>
          </Form.Item>
        ) : (
          <Form.Item name="candidate_id" label="Select Candidate" rules={[{ required: true }]}>
            <Select placeholder="Choose candidate..." showSearch optionFilterProp="children">
              {candidatesList
                .filter(c => (ayFilter === 'all' || String(c.academic_year_id) === String(ayFilter)))
                .filter(c => (standardFilter === 'all' || String(c.standard_id) === String(standardFilter)))
                .map(c => (
                  <Option key={c.candidate_id} value={c.candidate_id}>
                    {c.name} (Candidate ID: {c.candidate_id}{c.combination ? ` • Comb: ${c.combination}` : ''})
                  </Option>
                ))}
            </Select>
          </Form.Item>
        )}

        <Form.Item name="academic_year_id" label="Academic Year">
          <Select placeholder="Select Academic Year (Optional)">
            {academicYears.map(ay => (
              <Option key={ay.academic_year_id} value={ay.academic_year_id}>
                {ay.academic_year}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="status" label="Mapping Status" rules={[{ required: true }]}>
          <Select>
            <Option value="Active">Active</Option>
            <Option value="Inactive">Inactive</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
}
